export default __webpack_public_path__ + "static/media/diamond.801f1d72.svg";